module.exports = __webpack_public_path__ + "img/31.245db94f.png";